import { ActionTypes } from '../constants/index';

export function getDomains(): Object {
  return {
    type: ActionTypes.DOMAIN_GET_REQUEST,
    payload: {},
  };
}

export function refreshDomains(): Object {
  return {
    type: ActionTypes.DOMAIN_REFRESH_ALL_REQUEST,
    payload: {},
  };
}

export function addDomain(domainName: string): Object {
  return {
    type: ActionTypes.DOMAIN_ADD_REQUEST,
    payload: { domainName },
  };
}

export function deleteDomain(domainUrlsafe: string): Object {
  return {
    type: ActionTypes.DOMAIN_DELETE_REQUEST,
    payload: { domainUrlsafe },
  };
}

export function checkDomainReachability(domainUrlsafe: string): Object {
  return {
    type: ActionTypes.DOMAIN_CHECK_REACHABILITY_REQUEST,
    payload: { domainUrlsafe },
  };
}

export function refreshDomain(domainUrlsafe: string): Object {
  return {
    type: ActionTypes.DOMAIN_REFRESH_REQUEST,
    payload: { domainUrlsafe },
  };
}

// export function showAddDomainForm(): Object {
//   return {
//     type: ActionTypes.DOMAIN_SHOW_ADD_FORM,
//     payload: {},
//   };
// }
//
// export function hideAddDomainForm(): Object {
//   return {
//     type: ActionTypes.DOMAIN_HIDE_ADD_FORM,
//     payload: {},
//   };
// }



// WEBPACK FOOTER //
// ./scripts/actions/domain.js